const formatDateDDMMYYYY = (dateValue) => {
    if (!dateValue) return "";

    const date = new Date(dateValue);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}


export default formatDateDDMMYYYY;